module.exports = __webpack_public_path__ + "img/qrcode.51547ba.png";